import 'focus-visible';
import 'svgxuse/svgxuse';
import './polyFills';
import initLocationSearch from './locationSearch';
import initNavigation from './navigation';
import { initCollapse } from './collapse';
import { initSelects } from './selects';
import { lazyLoadExternalVideo } from './lazyloadExternalVideo';
import { initPageAnchors } from './pageAnchors';
import { initToTop } from './toTop';
import { initBrowserUpdate } from './browserUpdate';
import { initDatePickers } from './datepicker';
import { initFaqOverview } from './faq';
import { initDataLayers } from './Datalayers';
import { initOffCanvas } from './offCanvas';
import { initModals } from './modals';
import { initNotificationBanner } from './notificationBanner';
import { initDueDateCalculator } from './dueDateCalculator';
import { initContactWizard } from './contactWizard';
import { lazyLoadImages } from './lazyLoadImages';
import { inertWithCookieBanner } from './inertWithCookieBanner';
import { initGovFlandersWidgets } from './govFlanders';

document.addEventListener('DOMContentLoaded', () => {
    inertWithCookieBanner();
    initLocationSearch();
    initCollapse();
    initSelects();
    initPageAnchors();
    initToTop();
    initBrowserUpdate();
    initDatePickers();
    initNavigation();
    initFaqOverview();
    initDataLayers();
    initOffCanvas();
    initModals();
    initNotificationBanner();
    initDueDateCalculator();
    initContactWizard();
    initGovFlandersWidgets();
    lazyLoadExternalVideo();
    lazyLoadImages();
});
